import styled from 'styled-components';

interface InputBorderProps {
	error: boolean;
}

export const InputBorder = styled.div<InputBorderProps>`
	background-color: ${({ error }) => (error ? 'rgba(var(--error)) !important' : 'rgba(var(--primary))')};
`;

interface InputHintProps {
	error: boolean;
}

export const InputHint = styled.div<InputHintProps>`
	display: block;
	font: var(--caption);
	min-height: 20px;
	padding: 0 0 0 12px;
	margin-top: 4px;
	transition:
		transform 250ms ease-in,
		color 250ms ease-in;
	color: ${({ error }) => (error ? 'rgba(var(--error))' : 'rgba(var(--font-supportive))')};
`;

export const Input = styled.input`
	&:focus {
		& ~ .hint {
			color: rgba(var(--font-supportive), 1);
		}

		& ~ .form__border {
			background-color: rgba(var(--primary));
		}
	}
`;
